module.exports = __webpack_public_path__ + "static/nixiangtanta-86e32c5ee57c75ffdcd575e8b319cf34.jpg";